export default __webpack_public_path__ + "static/media/Nav-Students active.03724d1d.svg";